import { render, staticRenderFns } from "./CopyCodeBtn.vue?vue&type=template&id=1f10337a&scoped=true&"
import script from "./CopyCodeBtn.vue?vue&type=script&lang=ts&"
export * from "./CopyCodeBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CopyCodeBtn.vue?vue&type=style&index=0&id=1f10337a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10337a",
  null
  
)

export default component.exports